<template>
  <div style="background-color: #F5F7FA;height: 100%;">
    <div style="padding: 20px;position: relative;">
        <template>
          <el-table v-loading="tableLoading"  :data="tableData" :height="400" border>

            <el-table-column prop="Type" label="报警类型"></el-table-column>
            <el-table-column prop="Time" label="报警时间" ></el-table-column>

          </el-table>
          <div style="text-align: left;background-color: #fff;padding: 10px;">
            <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="20"
                  :current-page.sync="currentPage"  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>
        </template>
      </div>
    </div>
</template>

<script>




import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

export default {
  name: "WatchData",
  data() {
    return {
      tableLoading:false,
      userCode: '',
      pageIndex:'',
      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,

    }
  },
  components: {

  },

  methods: {
    init(userCode) {
      this.userCode = userCode;
      this.getBaoJingByPhone();
    },
    closeSelf() {
      this.$emit("closeAlarmInfo");
    },
    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getBaoJingByPhone();
    },
    getBaoJingByPhone(){
      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$institutionUrl + "Positioning/ListBaoJingByPhone",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userCode: this.userCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then(
          (response) => {
            this.tableLoading=false
            if (response.data.error === 0) {
              this.tableData=response.data.data;
              this.totalItems=response.data.data.length
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },




  }


}
</script>

<style lang="scss" scoped>


</style>